<template>
  <!--   Main Content Start Here   -->
  <main>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>
    <section class="dashboard_wraper">
      <div class="container_large">
        <div class="row">
          <!-- starting side bar -->
          <sidebar-component></sidebar-component>
          <!-- ending sidebar  -->
          <div class="col-md-12 col-lg-9">
            <div class="dashboard_card">
              <h2>Faqs</h2>
              <div class="account_form">
                <form method="" action="" @submit.prevent="FaqsAction()">
                  <div class="row">
                    <div
                      class="alert alert-success alert-dismissible"
                      v-if="status && status.success && status.success == 200"
                    >
                      <strong>Success!</strong> Action performed successfully.
                    </div>
                    <div class="col-md-12">
                      <div class="form_group">
                        <label>Question</label>
                        <input
                          type="text"
                          name=""
                          v-model="formObj.question"
                          autofocus
                          required
                        />
                        <v-errors :errors="errorFor('question')"></v-errors>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form_group">
                        <label>Answer</label>
                        <textarea
                          name=""
                          rows="5"
                          v-model="formObj.answer"
                          class="w-100"
                        ></textarea>
                        <v-errors :errors="errorFor('answer')"></v-errors>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="order_buttons">
                      <input
                        type="submit"
                        class="button primary_button"
                        value="Save"
                      />
                    </div>
                  </div>
                  <hr />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <!--   Main Content End Here   -->
</template>
<script>
import sidebarComponent from "./sidebar";
import { is422 } from "../../utils/response";
import validationErrors from "../../mixins/validationErrors";
import faqsApis from "../../Apis/faqs";

export default {
  mixins: [validationErrors],
  components: {
    sidebarComponent,
  },
  data() {
    return {
      loader: true,
      status: null,
      errors: null,
      formObj: {
        id: null,
        question: null,
        answer: null,
      },
    };
  },
  methods: {
    async FaqsAction() {
      this.loader = true;
      if (!this.formObj.id) {
        faqsApis
          .requestFaqs("post", this.formObj)
          .then((response) => {
            console.log(response);
            if (response.status == 200 || response.status == 204) {
              this.loader = false;
              this.status = { success: 200 };

              setTimeout(() => {
                this.$router.push({ name: "admin-faqs" });
              }, 1000);
            }
          })
          .catch((error) => {
            console.log(error);
            this.loader = false;
            if (is422(error)) {
              this.errors = error.response.data.errors;
            }
            this.status =
              error.response && error.response.status
                ? error.response.status
                : "";
          })
          .then(() => {
            this.loader = false;
          });
      } else {
        faqsApis
          .requestFaqs("put", this.formObj)
          .then((response) => {
            console.log(response);
            if (response.status == 200 || response.status == 204) {
              this.loader = false;
              this.status = { success: 200 };

              setTimeout(() => {
                this.$router.push({ name: "admin-faqs" });
              }, 1000);
            }
          })
          .catch((error) => {
            console.log(error);
            this.loader = false;
            if (is422(error)) {
              this.errors = error.response.data.errors;
            }
            this.status =
              error.response && error.response.status
                ? error.response.status
                : "";
          })
          .then(() => {
            this.loader = false;
          });
      }
    },
  },
  async created() {
    if (this.$route.params.id) {
      this.formObj = (await faqsApis.getById(this.$route.params.id)).data;
    }
    setTimeout(() => {
      this.loader = false;
    }, 1000);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/addUpdateFaqs.vue